export const ADMIN = "ADMIN";
export const CUSTOMER = "CUSTOMER";
export const ANALYST = "ANALYST";